import type { State } from './state'
import type { MutationTree } from 'vuex'

export const mutations = {
  updateAPIToken(state: State, token: APIToken): void {
    state.apiToken = token
  },

  clearAPIToken(state: State): void {
    state.apiToken = undefined
  },
} as MutationTree<State>
